<app-card-content [border]="false" [headerColor]="true" icon="pi pi-history" title="Histórico" subtitle="Situação e inscrições secundárias">
    <div card-header>
        <app-botao-acoes [label]="'Ações'" [items]="acoesAtivas" />
    </div>

    <app-tab-container [options]="optionsTab" [(selected)]="selectedTab" (onChanged)="onTabChanged($event)" [useHeader]="false">
        <div tab-header-right>
            <app-table-view-switcher [mostrarTimeline]="true" [(timelineAtiva)]="timelineAtiva" [(viewMode)]="viewModeAtual" />
        </div>

        <!-- Situação do Médico (conteúdo direto no card principal) -->
        <app-tab-content [value]="'SITUACAO'">
            @if (loadingSituacao()) {
                <div class="text-color-secondary text-sm mb-2">Carregando situação...</div>
            }
            @if (!loadingSituacao() && erroSituacao) {
                <div class="text-red-500 text-sm mb-2">{{ erroSituacao }}</div>
            }
            @if (timelineAtiva()) {
                <app-timeline-inscricoes [eventos]="eventosSituacao()" [indiceSelecionado]="indiceEventoSituacao" (selecionar)="onEventoSituacaoSelecionado($event)" />
            } @else {
                <app-custom-table
                    #tabelaSituacao
                    [data]="situacaoMedico()"
                    [metadata]="situacaoTableMetadata()"
                    [loading]="loadingSituacao()"
                    [columnOrder]="situacaoMedicoColumnOrder"
                    [showActions]="false"
                    [showExpandButton]="false"
                    [showViewSwitcher]="false"
                    [initialViewMode]="viewModeAtual()"
                    [rowClickable]="true"
                    (onRowClick)="onSituacaoRowClick($event)"
                    [useCustomCard]="true"
                    [cardColumns]="2"
                    [permissaoUf]="pessoa()?.uf ?? null"
                >
                    <ng-template pTemplate="card" let-rowData>
                        <app-card-container [hoverEfect]="true" [selected]="selectionSituacao === rowData" (click)="onSituacaoRowClick(selectionSituacao === rowData ? null : rowData)" class="historico-card-item cursor-pointer block h-full">
                            <div class="historico-card-header">
                                <div class="historico-card-title-row">
                                    @if (rowData.origemDestino) {
                                        <div class="historico-card-tipo-badge">
                                            <p-tag [value]="rowData.origemDestino" [rounded]="true" [style]="{ 'background-color': 'var(--p-blue-500)', color: '#ffffff' }"></p-tag>
                                        </div>
                                    }
                                    <h3 class="historico-card-title" [title]="rowData.descricao">
                                        {{ obterDescricaoExibicao(rowData) }}
                                    </h3>
                                </div>
                            </div>

                            <div class="historico-card-body">
                                <div class="historico-card-row">
                                    <i class="pi pi-calendar"></i>
                                    <span class="historico-card-field-value">
                                        Data Referência: <span>{{ rowData.dataReferencia || 'N/A' }}</span>
                                    </span>
                                </div>

                                @if (rowData.origemDestino) {
                                    <div class="historico-card-row">
                                        <i class="pi pi-map-marker"></i>
                                        <span class="historico-card-field-value">
                                            Origem/Destino: <span>{{ rowData.origemDestino }}</span>
                                        </span>
                                    </div>
                                }

                                @if (rowData.dataCancelamento) {
                                    <div class="historico-card-row">
                                        <i class="pi pi-ban"></i>
                                        <span class="historico-card-field-value">
                                            Cancelamento: <span>{{ rowData.dataCancelamento }}</span>
                                        </span>
                                    </div>
                                }

                                @if (rowData.motivoCancelamento) {
                                    <div class="historico-card-row">
                                        <i class="pi pi-info-circle"></i>
                                        <span class="historico-card-field-value">
                                            Motivo: <span>{{ rowData.motivoCancelamento }}</span>
                                        </span>
                                    </div>
                                }
                            </div>
                        </app-card-container>
                    </ng-template>
                </app-custom-table>
            }
        </app-tab-content>

        <!-- Inscrição Secundária -->
        <app-tab-content [value]="'SECUNDARIA'">
            @if (loadingSecundaria()) {
                <div class="text-color-secondary text-sm mb-2">Carregando histórico...</div>
            }
            @if (!loadingSecundaria() && erroSecundaria) {
                <div class="text-red-500 text-sm mb-2">{{ erroSecundaria }}</div>
            }
            @if (timelineAtiva()) {
                <app-timeline-inscricoes [eventos]="eventosSecundaria()" [indiceSelecionado]="indiceEventoInscricao" (selecionar)="onEventoInscricaoSelecionado($event)" />
            } @else {
                <app-custom-table
                    #tabelaInscricao
                    [data]="historicoSecundaria()"
                    [metadata]="secundariaTableMetadata()"
                    [columnOrder]="inscricaoSecundariaColumnOrder"
                    [loading]="loadingSecundaria()"
                    [showActions]="false"
                    [showExpandButton]="false"
                    [showViewSwitcher]="false"
                    [initialViewMode]="viewModeAtual()"
                    [rowClickable]="true"
                    (onRowClick)="onInscricaoRowClick($event)"
                    [useCustomCard]="true"
                    [cardColumns]="2"
                    [permissaoUf]="pessoa()?.uf ?? null"
                >
                    <ng-template pTemplate="card" let-rowData>
                        <app-card-container [hoverEfect]="true" [selected]="selectionInscricao === rowData" (click)="onInscricaoRowClick(selectionInscricao === rowData ? null : rowData)" class="historico-card-item cursor-pointer block h-full">
                            <div class="historico-card-header">
                                <div class="historico-card-title-row">
                                    @if (rowData.ufDestino) {
                                        <div class="historico-card-tipo-badge">
                                            <p-tag [value]="rowData.ufDestino" [rounded]="true" [style]="{ 'background-color': 'var(--p-purple-500)', color: '#ffffff' }"></p-tag>
                                        </div>
                                    }
                                    <h3 class="historico-card-title" [title]="rowData.modoInscricao">
                                        {{ obterModoInscricaoExibicao(rowData) }}
                                    </h3>
                                </div>
                            </div>

                            <div class="historico-card-body">
                                <div class="historico-card-row">
                                    <i class="pi pi-calendar"></i>
                                    <span class="historico-card-field-value">
                                        Data Inscrição: <span>{{ rowData.dataInscricao || 'N/A' }}</span>
                                    </span>
                                </div>

                                @if (rowData.ufDestino) {
                                    <div class="historico-card-row">
                                        <i class="pi pi-map-marker"></i>
                                        <span class="historico-card-field-value">
                                            UF Destino: <span>{{ rowData.ufDestino }}</span>
                                        </span>
                                    </div>
                                }

                                @if (rowData.dataCancelamento) {
                                    <div class="historico-card-row">
                                        <i class="pi pi-ban"></i>
                                        <span class="historico-card-field-value">
                                            Data Cancelamento: <span>{{ rowData.dataCancelamento }}</span>
                                        </span>
                                    </div>
                                }
                            </div>
                        </app-card-container>
                    </ng-template>
                </app-custom-table>
            }
        </app-tab-content>
    </app-tab-container>
</app-card-content>

<!-- Diálogos -->
<p-dialog
    appDialogoPadrao="pi pi-ban"
    descricao="Data e motivo do cancelamento da inscrição."
    header="Informe o Cancelamento"
    [(visible)]="showExcluirSituacaoDialog"
    [closable]="true"
    [breakpoints]="{ '960px': '60vw', '640px': '90vw' }"
    [style]="{ width: '28rem' }"
    (onHide)="fecharDialogExcluirSituacao()"
>
    <form [formGroup]="excluirSituacaoForm" class="flex flex-col items-center gap-3 py-2">
        <div class="field w-18rem mx-auto text-center">
            <label class="block mb-1 text-center">Dt. Cancelamento</label>
            <p-inputmask mask="99/99/9999" placeholder="DD/MM/AAAA" formControlName="dataCancelamento" styleClass="w-full"></p-inputmask>
            @if (campoInvalido(excluirSituacaoForm, 'dataCancelamento')) {
                <small class="erro-campo">{{ mensagemErroCampo(excluirSituacaoForm, 'dataCancelamento') }}</small>
            }
        </div>
        <div class="flex w-fit mx-auto flex-nowrap justify-center gap-2">
            <p-button label="Cancelar Alteração" severity="danger" (onClick)="fecharDialogExcluirSituacao()"></p-button>
            <p-button label="Confimar Cancelamento" icon="pi pi-check" severity="success" [disabled]="!excluirSituacaoForm.get('dataCancelamento')?.value" (onClick)="confirmarExclusaoSituacao()" [appCan]="roleHistoricoCancelar"></p-button>
        </div>
    </form>
</p-dialog>

<p-dialog
    appDialogoPadrao="pi pi-info-circle"
    descricao="Detalhes do evento no histórico do registro."
    header="Mais Informações"
    [(visible)]="showMaisInformacoesDialog"
    [closable]="true"
    [breakpoints]="{ '960px': '60vw', '640px': '90vw' }"
    [style]="{ width: '30rem' }"
    (onHide)="fecharDialogMaisInformacoes()"
>
    <div class="grid gap-2">
        @for (item of detalhesMaisInformacoes; track item.label) {
            <div class="flex justify-between gap-4 border-b border-surface-200 pb-2">
                <span class="font-semibold">{{ item.label }}</span>
                <span class="text-right">{{ item.valor }}</span>
            </div>
        }
    </div>
</p-dialog>

<p-dialog
    appDialogoPadrao="pi pi-ban"
    descricao="Encerre a inscrição secundária do médico."
    header="Cancelar Inscrição Secundária"
    [(visible)]="showCancelarSecundariaDialog"
    [closable]="true"
    [breakpoints]="{ '960px': '60vw', '640px': '90vw' }"
    [style]="{ width: '28rem' }"
    (onHide)="fecharDialogCancelarSecundaria()"
>
    <form [formGroup]="cancelarSecundariaForm" class="flex flex-col items-center gap-3 py-2">
        <div class="field w-18rem mx-auto text-center">
            <label class="block mb-1 text-center">Dt. Cancelamento</label>
            <p-inputmask mask="99/99/9999" placeholder="DD/MM/AAAA" formControlName="dataCancelamento" styleClass="w-full"></p-inputmask>
            @if (campoInvalido(cancelarSecundariaForm, 'dataCancelamento')) {
                <small class="erro-campo">{{ mensagemErroCampo(cancelarSecundariaForm, 'dataCancelamento') }}</small>
            }
        </div>
        <div class="flex w-fit mx-auto flex-nowrap justify-center gap-2">
            <p-button label="Cancelar Alteração" severity="secondary" [disabled]="savingCancelarSecundaria()" (onClick)="fecharDialogCancelarSecundaria()"></p-button>
            <p-button
                label="Confimar Cancelamento"
                icon="pi pi-check"
                severity="success"
                [loading]="savingCancelarSecundaria()"
                [disabled]="cancelarSecundariaForm.invalid || savingCancelarSecundaria()"
                (onClick)="confirmarCancelamentoSecundaria()"
                [appCan]="roleHistoricoCancelar"
            ></p-button>
        </div>
    </form>
</p-dialog>

<p-dialog
    appDialogoPadrao="pi pi-plus"
    descricao="Registre a inscrição do médico em outra UF."
    header="Nova Inscrição Secundária"
    [(visible)]="showNovaInscricaoDialog"
    [closable]="true"
    [breakpoints]="{ '960px': '75vw', '640px': '95vw' }"
    [style]="{ width: '40vw' }"
    [styleClass]="'nova-inscricao-dialog'"
    (onHide)="fecharDialogNovaInscricao()"
>
    <form [formGroup]="novaInscricaoForm" class="grid grid-cols-1 md:grid-cols-2 gap-3">
        <div class="field">
            <label class="block mb-1">Dt. Inscrição</label>
            <p-inputmask mask="99/99/9999" placeholder="DD/MM/AAAA" formControlName="dataInscricao" styleClass="w-full" [readonly]="savingNovaInscricao()"></p-inputmask>
            @if (campoInvalido(novaInscricaoForm, 'dataInscricao')) {
                <small class="erro-campo">{{ mensagemErroCampo(novaInscricaoForm, 'dataInscricao') }}</small>
            }
        </div>
        <div class="field">
            <label class="block mb-1">Destino</label>
            <app-estado-select [uf]="novaInscricaoForm.get('destinoUF')?.value ?? ''" (ufChange)="novaInscricaoForm.get('destinoUF')?.setValue($event)" [disabled]="savingNovaInscricao()"></app-estado-select>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <div class="flex justify-end gap-2">
            <p-button label="Cancelar" severity="secondary" (onClick)="fecharDialogNovaInscricao()" [disabled]="savingNovaInscricao()"></p-button>
            <p-button
                label="Salvar"
                icon="pi pi-check"
                (onClick)="criarNovaInscricao()"
                severity="success"
                [loading]="savingNovaInscricao()"
                [disabled]="savingNovaInscricao() || !novaInscricaoForm.get('dataInscricao')?.value || !novaInscricaoForm.get('destinoUF')?.value"
                [appCan]="roleHistoricoInscricaoSecundaria"
            ></p-button>
        </div>
    </ng-template>
</p-dialog>
